import { ApolloLink } from './ApolloLink';
export var from = ApolloLink.from;
//# sourceMappingURL=from.js.map